import * as React from 'react';

function SvgPicks(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="16" viewBox="0 0 11 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.7625 8.91667H1.1875L8.3375 1.125L6.55 7.08333H10.125L2.975 14.875L4.7625 8.91667Z"
        stroke="#052643"
        strokeLinejoin="round"
        strokeWidth="1.03125"
      />
    </svg>
  );
}

export default SvgPicks;
